import { I18n } from "i18n-js";

const locale = document.documentElement.lang;

const response = await fetch(`/locales/${locale}_v2.json`);
const translations = await response.json();

const editorResponse = await fetch(`/locales/editor/${locale}.json`);
const rawEditorTranslations = await editorResponse.json();

const editorTranslations = { [locale]: rawEditorTranslations };

const i18n = new I18n({
  [locale]: {
    ...translations[locale],
    ...editorTranslations[locale],
  },
});

i18n.locale = locale;
i18n.defaultLocale = "en";
window.I18n = i18n;
